<template>
    <div>
        <a-button class="mb10" type="primary" @click="$refs.editLimitModalRef.showFun()">{{$t('program.speak_config_add'/*新增*/)}} </a-button>
        <a-spin :spinning="loading">
            <!--  表格  -->
            <a-table
                ref="table"
                :columns="columns"
                :data-source="dataSource"
                :expand-icon-column-index="1"
                :defaultExpandAllRows="true">
                <template slot="period" slot-scope="text">
                    {{text == 1 ? $t('program.all'/*全部*/) : $t('program.every_day'/*每天*/)}}
                </template>
                <template slot="roles" slot-scope="text">
                    <div v-if="text == 1">{{$t('program.all'/*全部*/ )}}</div>
                    <div v-if="text == 2">{{$t('program.host_type'/*主持类*/ )}}</div>
                    <div v-if="text == 3">{{$t('program.discuss_type'/*讨论类*/ )}}</div>
                    <div v-if="text == 4">{{$t('program.speaker_type'/*讲者类*/ )}}</div>
                </template>
                <template slot="action" slot-scope="text, record">
                    <a @click="$refs.editLimitModalRef.showFun(record)">
                        {{$t('layout.edit')}}
                    </a>
                    <a-divider type="vertical" />
                    <a class="del-button" @click="handleDelEvent(record.id, index)">
                        {{$t('layout.delete')}}
                    </a>
                </template>
            </a-table>
        </a-spin>
        <edit-limit-modal ref="editLimitModalRef" @reset="getAddLimit"/>
    </div>
</template>
<script>
import editLimitModal from './components/edit-limit-modal.vue'
export default {
    name: 'addLimit',
    components: {
        editLimitModal
    },
    data() {
        return {
            dataSource: [],
            columns: [
                
                {
                    title: this.$t('program.limit_config_id'/*配置ID*/),
                    dataIndex: 'id',
                    align: 'left',
                    fixed: 'left',
                    width: 200
                },
                {
                    title: this.$t('program.limit_period'/*限制时段*/),
                    dataIndex: 'restriction_period',
                    scopedSlots: { customRender: 'period' },
                    align: 'left',
                    width: 200
                },
                {
                    title: this.$t('program.limit_roles'/*限制角色*/),
                    dataIndex: 'restriction_roles',
                    scopedSlots: { customRender: 'roles' },
                    align: 'left',
                },
                {
                    title: this.$t('program.limit_times'/*限制人员添加次数*/),
                    dataIndex: 'limit',
                    align: 'left',
                },
                {
                    title: this.$t('web.actions'/*操作*/),
                    dataIndex: 'action',
                    scopedSlots: { customRender: 'action' },
                    align: 'center'
                }
            ],
            loading: false
        };
    },
    methods: {
        handleEdit (item) {
        },
        getAddLimit () {
            this.$request.get({ url: 'getAddLimit' }).then((res) => {
                this.dataSource = res.data
            })
        },
        handleDelEvent (rules_id, index) {
            this.$confirm({
                title: this.$t('web.tips'/*提示*/),
                content: this.$t('program.confirm_delete_category'/*确定要删除该限制吗？*/),
                okText: this.$t('web.ok'/*确定*/),
                cancelText: this.$t('web.cancel'/*取消*/),
                onOk: () => {
                    this.$request.post({ url: 'delProgramLimit', data: { rules_id } }).then(res => {
                        this.$message.success(this.$t('authority.delete_success'/*删除成功*/));
                        this.dataSource.splice(index, 1)
                    });
                }
            });
        }
    },
    mounted() {
        this.getAddLimit();
    }
};
</script>